import { createElement, useEffect, useState } from 'react';
import { ProTable as OriginalProTable } from '@ant-design/pro-components';
import { Card, Space } from 'antd';
import ImportExcelButton from '../edit-pro-table/components/ImportExcelButton';
import ExportExcelButton from '../edit-pro-table/components/ExportExcelButton';
const ProTable = ({ rowKey = 'id', columns = [], dataSource = [], tableName, headerTitle, exportButton, importButton, importTemplateList, tableHeaderBold, tableHeaderSize, toolBarRender, screen_inner_id, scroll = {}, pagination, ...otherProps }) => {
    const [tableDataSource, setTableDataSource] = useState([]);
    const [originalColumns, setOriginalColumns] = useState([]);
    const screenStructure = screen_inner_id ? screen_inner_id.split('__')[1] : '';
    console.log('proTable otherProps', otherProps);
    console.log('proTable dataSource', dataSource);
    const extraColumns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 100,
            fixed: 'left',
            hideInTable: true,
        },
    ];
    useEffect(() => {
        setOriginalColumns(columns);
        if (dataSource.length) {
            setTableDataSource(dataSource);
        }
    }, [dataSource]);
    const handleImport = async (response) => {
        if (!response || !response.columns || !response.data || !response.data.length)
            return;
        const newData = response.data.map((item, index) => ({
            id: index,
            ...item,
        }));
        setOriginalColumns(response.columns);
        setTableDataSource(newData);
        if (!screenStructure)
            return;
        screenStructure && window.screenStructures && (window.screenStructures[screenStructure] = newData);
    };
    let tableClassName = 'pro-table';
    if (tableHeaderBold) {
        tableClassName += ' th-bold';
    }
    if (tableHeaderSize) {
        tableClassName += ` th-font-${tableHeaderSize}`;
    }
    return (createElement(Card, { bordered: false, bodyStyle: { padding: 0 }, style: { width: '100%' } },
        (exportButton || importButton) && createElement(Card, { bordered: false, bodyStyle: { padding: '0 0 12px' } },
            createElement(Space, null,
                exportButton && createElement(ExportExcelButton, { tableDataSource: tableDataSource, columns: originalColumns, tableName: tableName }),
                importButton && createElement(ImportExcelButton, { importTemplateList: importTemplateList, onImport: handleImport }))),
        createElement(OriginalProTable, { ...otherProps, rowKey: rowKey, headerTitle: headerTitle, search: false, columns: [
                ...originalColumns,
                ...extraColumns,
            ], dataSource: tableDataSource, scroll: scroll, pagination: {
                showSizeChanger: true,
                showQuickJumper: true,
                ...pagination,
                defaultPageSize: 10,
                showTotal: (total) => `共 ${total} 条数据`,
                pageSizeOptions: ['10', '20', '30', '50', '100'],
            }, toolBarRender: false, style: { width: '100%' }, className: tableClassName })));
};
export default ProTable;
